module.exports = __webpack_public_path__ + "img/customerBind.b7db9c97.svg";